import {create} from 'zustand'
import {devtools, persist} from 'zustand/middleware'
import * as React from "react";

type Store = {
  selectedAnswerList: []
  setSelectedAnswerList: (by: []) => void
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        selectedAnswerList: [],
        setSelectedAnswerList: (by: []) => set((state) => ({ selectedAnswerList: by })),
      }),
      { name: 'checkStore' },
    ),
  ),
)

export default useStore;